import Container from "components/general/Container";
import { Tab, TabContainer } from "components/general/Tabs";
import ItemCardList from "components/item/ItemCardList";
import ItemListItem from "components/item/ItemListItem";
import SiteItem from "components/sites/SiteItem";
import { Box, Button, H4, HStack, Link, Text } from "components/ui";
import React from "react";
import { Container as GridContainer } from "react-native-flex-grid";
import { FlatList, ScrollView } from "react-native-gesture-handler";
import { useGetRecommendedQuery } from "store/abcoApi";
import { useSiteSearch } from "utils/hooks/useSiteSearch";
import SearchResultHeading from "../SearchResultHeading";
import ServicesItem from "../ServicesItem";
import TrainingItem from "../TrainingItem";
import WebContentItem from "../WebContentItem";
import Section from "../Section";
import { Dimensions } from "react-native";

type Props = {};

const HeaderSearchResults = (props: Props) => {
	const { searchResults, isOpen, searchTerm, close } = useSiteSearch();
	const { data: recommendedProductCollection } = useGetRecommendedQuery();
	const screenHeight = Dimensions.get("window").height;
	if (!isOpen) {
		return null;
	}
	const hasItems = searchResults?.itemCollection?.list?.length > 0;
	const hasSites = searchResults?.siteCollection?.list?.length > 0;

	const tabCollection = [];
	if (hasItems) {
		tabCollection.push("Products & Equipment");
	}
	if (hasSites) {
		tabCollection.push("Sites");
	}

	return (
		<Box style={{ maxHeight: screenHeight - 100 }}>
			<ScrollView scrollEventThrottle={16} style={{ flex: 1 }} contentContainerStyle={{ flexGrow: 1 }}>
				<Container
					noMargin
					isFit
					sx={{
						borderBottomLeftRadius: 24,
						borderBottomRightRadius: 24,
						backgroundColor: "white",
						paddingBottom: 0,
						width: "100% !important",
						flex: 1,
					}}
				>
					<Box marginTop={60}>{/* <CreditCardIconHandler type="visa" /> */}</Box>
					{tabCollection.length === 0 || searchTerm.length === 0 ? (
						<Section bg="transparent" paddingTop={0} paddingHorizontal={0}>
							<H4 sx={{ fontFamily: "Roboto_700Bold", marginBottom: 16 }}>Recommended for you</H4>
							<ItemCardList isOnNavigation list={recommendedProductCollection} />
						</Section>
					) : null}
					{searchTerm.length > 0 && (
						<TabContainer>
							{tabCollection.length > 1 && (
								<Tab id="all" title="All">
									<Box marginBottom={120}>
										<SearchResultHeading title="All" resultCount={searchResults?.itemCollection?.list.length + searchResults?.siteCollection?.list.length} />
										<Box bg="$neutral25">
											<FlatList data={searchResults?.itemCollection?.list.slice(0, 4)} renderItem={({ item }) => <ItemListItem isOnNavigation isOnSearch item={item} />} keyExtractor={(item) => item.stockcode} />
										</Box>
										<Button isLink href={`/search?term=${searchTerm}&tab=products`} onPress={close}>
											<HStack paddingVertical={28} gap={6} paddingHorizontal={20}>
												<Text color="$primarylight">See all</Text>
												<Text color="$primarylight" fontFamily="Roboto_700Bold">
													{searchResults?.itemCollection?.metaData?.totalItemCount} product & equipment results
												</Text>
											</HStack>
										</Button>
										<SearchResultHeading title="Sites" resultCount={searchResults?.siteCollection?.metaData?.totalItemCount} />
										<Box gap={12}>
											<Box bg="$neutral25">
												<GridContainer
													noPadding
													style={{
														marginLeft: 0,
														width: "100%",
														maxWidth: "100%",
														marginBottom: 16,
													}}
												>
													{searchResults?.siteCollection?.list?.slice(0, 4).map((site: any) => {
														return (
															<Link
																href={"/site/" + site.id}
																key={site.id}
																onPress={close}
																component={(hovered: boolean) => {
																	var styleData = {
																		marginLeft: 0,
																		marginRight: 0,
																		paddingHorizontal: 16,
																		paddingVertical: 18,
																		marginBottom: 14,
																	};

																	if (hovered) {
																		// @ts-ignore
																		styleData = { ...styleData, backgroundColor: "#E1E9F0" };
																	}
																	return <SiteItem isOnSearch data={site} styleData={styleData} />;
																}}
															></Link>
														);
													})}
												</GridContainer>
											</Box>
										</Box>
										{/* <SearchResultHeading title="Training" resultCount={searchResults?.siteCollection?.list.length} /> */}
										<Box bg="$neutral25">
											<TrainingItem />
											<TrainingItem />
											<TrainingItem />
										</Box>
										<SearchResultHeading title="Services" resultCount={searchResults?.siteCollection?.list.length} />
										<Box bg="$neutral25">
											<ServicesItem />
											<ServicesItem />
											<ServicesItem />
										</Box>
										<SearchResultHeading title="Web Content" resultCount={searchResults?.siteCollection?.list.length} />
										<Box bg="$neutral25">
											<WebContentItem title="Meet the Team: Cleaning Experts" type="web" />
											<WebContentItem title="Meet the Team: Cleaning Experts" type="blog" />
											<WebContentItem title="Meet the Team: Cleaning Experts" type="blog" />
											<WebContentItem title="Meet the Team: Cleaning Experts" type="web" />
											<WebContentItem title="Meet the Team: Cleaning Experts" type="faq" />
											<WebContentItem title="Meet the Team: Cleaning Experts" type="web" />
										</Box>
									</Box>
								</Tab>
							)}

							{hasItems && (
								<Tab id="products" title="Products & Equipment">
									<Box marginBottom={120}>
										<SearchResultHeading title="Products & Equipment" resultCount={searchResults?.itemCollection?.metaData?.totalItemCount} />
										<Box bg="$neutral25">
											<FlatList data={searchResults?.itemCollection?.list.slice(0, 4)} renderItem={({ item }) => <ItemListItem isOnSearch isOnNavigation={true} item={item} />} keyExtractor={(item) => item.stockcode} />
										</Box>
										<Link href={`/search?term=${searchTerm}&tab=products`} onPress={close}>
											<HStack paddingVertical={28} gap={6} paddingHorizontal={20}>
												<Text color="$primarylight">See all</Text>
												<Text color="$primarylight" fontFamily="Roboto_700Bold">
													{searchResults?.itemCollection?.metaData?.totalItemCount} product & equipment results
												</Text>
											</HStack>
										</Link>
									</Box>
								</Tab>
							)}

							{hasSites && (
								<Tab id="sites" title="Sites">
									<SearchResultHeading title="Sites" resultCount={searchResults?.siteCollection?.list.length} />
									<Box gap={12}>
										<Box bg="$neutral25">
											<GridContainer
												noPadding
												style={{
													marginLeft: 0,
													width: "100%",
													maxWidth: "100%",
												}}
											>
												{searchResults?.siteCollection?.list?.slice(0, 4).map((site: any) => {
													return (
														<Link
															href={"/site/" + site.id}
															key={site.id}
															onPress={close}
															component={(hovered: boolean) => {
																var styleData = {
																	marginLeft: 0,
																	marginRight: 0,
																	paddingHorizontal: 16,
																	paddingVertical: 18,
																	borderRadius: 8,
																	marginBottom: 14,
																};

																if (hovered) {
																	// @ts-ignore
																	styleData = { ...styleData, backgroundColor: "#E1E9F0" };
																}
																return <SiteItem isOnSearch data={site} styleData={styleData} />;
															}}
														></Link>
													);
												})}
											</GridContainer>
										</Box>
									</Box>
								</Tab>
							)}
						</TabContainer>
					)}
				</Container>
			</ScrollView>
		</Box>
	);
};

export default HeaderSearchResults;
